import styled from '@emotion/styled'
import { css } from '@emotion/react'

const Container = styled.section`
  & {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column nowrap;
    font-size: var(--fs-300);
    font-weight: 300;
    color: ${({ theme }) => theme.colors.secondary[900]};
    line-height: 1.5;
    text-align: center;
    white-space: pre;
  }

  h1 {
    font-weight: 500;
    font-size: var(--fs-500);
    margin: 0 0 4px 0;
  }

  .symbol-container {
    --height: 90px;
    margin: 0 0 20px 0;
    height: var(--height);
  }

  .symbol-container > svg {
    height: var(--height);
  }

  ${({ theme }) =>
    css(
      theme.size.mq({
        h1: {
          fontSize: [
            'var(--fs-100)',
            'var(--fs-100)',
            'var(--fs-300)',
            'var(--fs-500)',
          ],
        },
        '&': {
          fontSize: [
            'var(--fs-50)',
            'var(--fs-50)',
            'var(--fs-100)',
            'var(--fs-300)',
          ],
        },
        '.symbol-container': {
          '--height': ['66px', '66px', '82px', '90px'],
        },
      }),
    ).styles}}
`

export default Container
